import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { Tomes } from './components/Tomes';
import { InsideLook } from './components/InsideLook';
import { Bonuses } from './components/Bonuses';
import { Transformation } from './components/Transformation';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-white" data-id="element-0" data-mp="31cjpm4rtfv3h">
      <Hero data-id="element-1" data-mp="2wjqff1dkvuk0" />
      <main data-id="element-2" data-mp="2wj8dpp85co4p">
        <PainPoints data-id="element-3" data-mp="2wifhhi6tdh0t" />
        <Solution data-id="element-4" data-mp="2wi5n7ieqknpb" />
        <Tomes data-id="element-5" data-mp="28u5yeo0zj7dd" />
        <InsideLook data-id="element-6" data-mp="28tw972nrl48q" />
        <Bonuses data-id="element-7" data-mp="28t4lee0esat0" />
        <Transformation data-id="element-8" data-mp="28sl3uyeo7ofi" />
        <Offer data-id="element-9" data-mp="28s31dk1f0dz5" />
        <Guarantee data-id="element-10" data-mp="23vktwcepa1j4" />
        <Testimonials data-id="element-11" data-mp="23w4c7u89irxo" />
        <Faq data-id="element-12" data-mp="23utas12ahw9q" />
        <FinalCta data-id="element-13" data-mp="23t8heerpojdg" />
      </main>
      <Footer data-id="element-14" data-mp="3ik7fqfdqo9q4" />
    </div>;
}